import React from 'react';
import { cn } from '@/lib/utils';
import { SEGMENTED_INDICATOR, segmentClass } from './segmentedStyles';

/**
 * Choix exclusif en pastilles (FR | EN, kg | lbs, Reçues | Réglages…) au dessin
 * des sélecteurs coach : rail blanc 5 %, pastille cuivre qui glisse sous le
 * choix actif. Les choix ont tous la même largeur, donc la pastille se place
 * en pur CSS (translateX d'une largeur par rang) : pas de mesure, et rien de
 * lourd dans le bundle principal, contrairement à SegmentedControl.
 *
 * options : [{ value, label }] · asTabs : role tablist/tab au lieu de group/pressed
 * className : ex. « grid w-full » pour occuper toute la largeur ; disabled : tout le groupe.
 */
const PillToggleGroup = ({ ariaLabel, options, value, onSelect, testIdPrefix, asTabs = false, className, disabled = false }) => {
  const index = Math.max(0, options.findIndex((option) => option.value === value));
  return (
    <div
      role={asTabs ? 'tablist' : 'group'}
      aria-label={ariaLabel}
      className={cn('relative inline-grid auto-cols-fr grid-flow-col gap-1 rounded-full bg-white/[0.05] p-1', className)}
    >
      <span
        aria-hidden="true"
        className={cn(
          SEGMENTED_INDICATOR,
          'bottom-1 left-1 top-1 transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
        )}
        style={{
          // Largeur d'un choix : (rail − marges − espaces) / nombre de choix.
          width: `calc((100% - 8px - ${(options.length - 1) * 4}px) / ${options.length})`,
          transform: `translateX(calc(${index * 100}% + ${index * 4}px))`,
        }}
      />
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            {...(asTabs ? { role: 'tab', 'aria-selected': active } : { 'aria-pressed': active })}
            data-testid={testIdPrefix ? `${testIdPrefix}-${option.value}` : undefined}
            onClick={() => onSelect(option.value)}
            disabled={disabled}
            className={cn(segmentClass(active, 'sm'), 'z-10 min-w-[56px] duration-300 disabled:opacity-50')}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default PillToggleGroup;
